// Paging for the board lists (ticket 187). The list routes return one page, the true match count
// (`total`) and `next_cursor` (null on the last page). A board keeps `{ loaded, total, cursor }`
// per view and asks for the next page with `cursor`, so a card removed or moved between pages
// never makes the list skip one.
export const PAGE_LIMIT = 500;

// Append a fetched page, dropping cards the board already holds (a card created or moved since
// the first page can show up again at a page boundary).
export const appendNew = (list, items) => {
  const seen = new Set(list.map(o => o.opportunity_id));
  return [...list, ...items.filter(o => !seen.has(o.opportunity_id))];
};

// Counters for a first page.
export const firstPage = (items, doc) => ({
  loaded: items.length,
  total: doc.total ?? items.length,
  cursor: doc.next_cursor ?? null,
});

// Counters after a following page arrives. A null cursor means nothing more can be loaded, so the
// bar goes away instead of offering a button that does nothing.
export const nextPage = (page, items, doc) => ({
  loaded: page.loaded + items.length,
  total: doc.total ?? page.total,
  cursor: doc.next_cursor ?? null,
});
